import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { DebtorsPage as DebtorsPageContent } from '@/features/debtors/debtors-page';

function DebtorsPage() {
  return (
    <RequireService service="DEBTOR_LIST">
      <DebtorsPageContent />
    </RequireService>
  );
}

export const Route = createFileRoute('/_app/debtors/')({ component: DebtorsPage });
